/** The `dynamicOptions` source that lists every stage in the workspace,
 *  grouped by workflow — registered in `widgets/controls.tsx`, read by the
 *  Projects by stage tile's Stage select and by its derived title. */
export const STAGES_SOURCE = "stages";
